import { useState, useRef, useEffect } from "react";
import { postData } from "../../../../ApiServices/ApiService";
import { ORG_EMP_ACCESS_PERMISSION_UPDATE } from '../../../../ApiServices/BaseURL';
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const UserAccessController = (userInfo, onRefresh) => {
    const { setIsLoginPopup } = useTheme();
    const [isManageAccessModalOpen, setIsManageAccessModalOpen] = useState(false);
    const [selUserAccessService, setSelUserAccessService] = useState(null);
    const [userAccessToggleUpdateError, setUserAccessToggleUpdateError] = useState({});
    const [userAccessToggleUpdateSuccess, setUserAccessToggleUpdateSuccess] = useState({});
    const [userAccessToggleUpdateLoading, setUserAccessToggleUpdateLoading] = useState({});

    const pageName="UserAccessPage"
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    const handleEditUserAccess = (userAccess) => {
        //console.log('handleEditUserAccess userAccess @', userAccess)
        setSelUserAccessService(userAccess);
        setIsManageAccessModalOpen(true);
    }

    const handleAccessToggleChange = async (service, status) => {
        console.log('Toggle is now:', service, 'status:', status);
        // setUserAccessToggleUpdateError((prev) => ({ ...prev, [service?.per_name_code]: '' }));
        // if (service?.per_name_sub_list?.every(subService => subService.per_origin?.toUpperCase() === "ROOT")) {
        //     console.log("Default Modules won't be editable.");
        //     setUserAccessToggleUpdateError((prev) => ({ ...prev, [service?.per_name_code]: "Default modules won't be editable." }));
        //     return;
        // }
        const updatedService = {
            ...service,
            per_name_sub_list: service?.per_name_sub_list?.map(subService => ({
                ...subService,
                is_active: subService.per_origin?.toUpperCase() === "ROOT" ? 1 : (status ? 1 : 0)
            }))
        };

        console.log("Updated Service Data access:", updatedService);
        await handleUpdateAccessToggle(updatedService);
    }

    const handleCloseManageAccessModal = () => {
        setSelUserAccessService(null);
        setIsManageAccessModalOpen(false);
    }

    const getActiveSubPerNamesOld = (list) => {
        const activeSubPerNames = list
            ?.filter((perNameSub) => perNameSub.is_active === 1)
            ?.map((perNameSub) => perNameSub.per_name_sub);

        // return activeSubPerNames?.length > 0 ? activeSubPerNames.join(", ") : "--";
        return {
            names: activeSubPerNames?.length > 0 ? activeSubPerNames.join(", ") : "--",
            isActive: activeSubPerNames?.length > 0
        }
    };

    const getActiveSubPerNames = (list) => {
        if (!list || list.length === 0) {
            return { names: "--", isActive: false, hasNonRootActive: false };
        }
        const result = list.reduce(
            (acc, perNameSub) => {
                if (perNameSub.is_active === 1) {
                    acc.names.push(perNameSub.per_name_sub);
                    // if (perNameSub.per_origin?.toUpperCase() !== "ROOT") {
                        acc.isActive = true; 
                    // }
                }
                if(perNameSub.per_origin?.toUpperCase() !== "ROOT") {
                    acc.hasNonRootActive = true;
                }
                return acc;
            },
            { names: [], isActive: false, hasNonRootActive: false }
        );

        return {
            names: result.names.length > 0 ? result.names.join(", ") : "--",
            isActive: result.isActive,
            hasNonRootActive: result.hasNonRootActive
        };
    };

    const handleUpdateAccessToggle = async (updatedService) => {
        console.log('updatedService :', updatedService);

        try {
            setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: '' }));
            setUserAccessToggleUpdateLoading((prev) => ({ ...prev, [updatedService?.per_name_code]: true }));
            setUserAccessToggleUpdateSuccess((prev) => ({ ...prev, [updatedService?.per_name_code]: '' }));

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                emp_id_auth: storedUserInfo?.emp_id,
                emp_id: userInfo?.emp_id,
                per_name_code: updatedService?.per_name_code,
                per_name_sub_list: updatedService?.per_name_sub_list
            }

            console.log('handleUpdateAccessToggle service payload', payLoad);
            const response = await postData(ORG_EMP_ACCESS_PERMISSION_UPDATE, payLoad);
            const responseData = await response.json();
            //console.log('handleUpdate service Data', responseData);
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setToggleUpdatedMessages((prevDeleted) => [...prevDeleted, updatedService?.per_name_code]);
                        setUserAccessToggleUpdateSuccess((prev) => ({ ...prev, [updatedService?.per_name_code]: responseData?.info }));
                        setTimeout(() => {
                            setUserAccessToggleUpdateSuccess((prev) => ({ ...prev, [updatedService?.per_name_code]: '' }));
                            onRefresh();
                        }, 2000);
                    } else {
                        setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: responseData?.info || 'Failed to update user access toggle.' }));
                        logFrontendException(storedUserId, pageName, "AccessUpdate", responseData?.info || '');
                    }
                } else {
                    setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: 'Failed to update user access toggle. Please try again.' }));
                    logFrontendException(storedUserId, pageName, "AccessUpdate", responseData?.info || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
                    logFrontendException(storedUserId, pageName, "AccessUpdate", response || '');
                } else {
                    setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: responseData?.info || 'Bad request. Please check the request parameters.' }));
                    logFrontendException(storedUserId, pageName, "AccessUpdate", response || '');
                }
                setIsLoginPopup(true)
            } else {
                setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: 'Unable to update user access toggle.' }));
                logFrontendException(storedUserId, pageName, "AccessUpdate", response || '');
            }
        } catch (error) {
            if (error.response) {
                setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: `Error: ${error.response.status}. ${error.response.data?.message || 'Failed to update user access toggle. Please check your network connection.'}` }));
                logFrontendException(storedUserId, pageName, "AccessUpdate", error || '');
            } else if (error.request) {
                setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: 'No response received from the server. Please check your network connection and try again.' }));
                logFrontendException(storedUserId, pageName, "AccessUpdate", error || '');
            } else {
                setUserAccessToggleUpdateError((prev) => ({ ...prev, [updatedService?.per_name_code]: `Failed to update user access toggle. Please check your network connection and try again.` }));
                logFrontendException(storedUserId, pageName, "AccessUpdate", error || '');
            }
        } finally {
            setUserAccessToggleUpdateLoading((prev) => ({ ...prev, [updatedService?.per_name_code]: false }));
        }
    };

    return {
        handleEditUserAccess,
        handleAccessToggleChange,
        isManageAccessModalOpen,
        handleCloseManageAccessModal,
        selUserAccessService,
        getActiveSubPerNames,
        userAccessToggleUpdateLoading, userAccessToggleUpdateError, userAccessToggleUpdateSuccess
    };

}

export default UserAccessController;